import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isCommonMediaClientError } from '@atlaskit/media-client';
import { ANALYTICS_MEDIA_CHANNEL, sanitiseAnalyticsPayload } from '@atlaskit/media-common/analytics';
import { createAndFireEvent } from '@atlaskit/analytics-next';
export var getFileAttributes = function getFileAttributes(metadata, fileStatus) {
  return {
    fileMediatype: metadata.mediaType,
    fileMimetype: metadata.mimeType,
    fileId: metadata.id,
    fileSize: metadata.size,
    fileStatus: fileStatus
  };
};
export var getRenderSucceededEventPayload = function getRenderSucceededEventPayload(fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext) {
  return {
    eventType: 'operational',
    action: 'succeeded',
    actionSubject: 'mediaCardRender',
    attributes: {
      fileMimetype: fileAttributes.fileMimetype,
      fileAttributes: fileAttributes,
      performanceAttributes: performanceAttributes,
      status: 'success',
      ssrReliability: ssrReliability,
      traceContext: traceContext,
      metadataTraceContext: metadataTraceContext
    }
  };
};
export var getDownloadSucceededEventPayload = function getDownloadSucceededEventPayload(fileAttributes, traceContext, metadataTraceContext) {
  return {
    eventType: 'operational',
    action: 'succeeded',
    actionSubject: 'mediaCardDownload',
    attributes: {
      fileMimetype: fileAttributes.fileMimetype,
      fileAttributes: fileAttributes,
      status: 'success',
      traceContext: traceContext,
      metadataTraceContext: metadataTraceContext
    }
  };
};
export var getCacheHitEventPayload = function getCacheHitEventPayload(cardPreviewAttributes) {
  return {
    eventType: 'operational',
    action: 'cache-hit',
    actionSubject: 'mediaCardCache',
    attributes: {
      cardPreviewAttributes: cardPreviewAttributes
    }
  };
};
export var getRemoteSuccessEventPayload = function getRemoteSuccessEventPayload(cardPreviewAttributes) {
  return {
    eventType: 'operational',
    action: 'Remote-success',
    actionSubject: 'mediaCardCache',
    attributes: {
      cardPreviewAttributes: cardPreviewAttributes
    }
  };
};
export var getRenderFailedExternalUriPayload = function getRenderFailedExternalUriPayload(fileAttributes, performanceAttributes) {
  return {
    eventType: 'operational',
    action: 'failed',
    actionSubject: 'mediaCardRender',
    attributes: {
      fileAttributes: fileAttributes,
      performanceAttributes: performanceAttributes,
      status: 'fail',
      failReason: 'external-uri'
    }
  };
};
export var getRenderErrorFailReason = function getRenderErrorFailReason(error) {
  return error.primaryReason || 'nativeError';
};
export var getRenderErrorErrorReason = function getRenderErrorErrorReason(error) {
  var secondaryError = error.secondaryError;
  if (isCommonMediaClientError(secondaryError)) {
    return secondaryError.reason;
  }
  return 'nativeError';
};
export var getRenderErrorErrorDetail = function getRenderErrorErrorDetail(error) {
  var _secondaryError$inner;
  var secondaryError = error.secondaryError;
  if (isCommonMediaClientError(secondaryError) && (_secondaryError$inner = secondaryError.innerError) !== null && _secondaryError$inner !== void 0 && _secondaryError$inner.message) {
    var _secondaryError$inner2;
    return (_secondaryError$inner2 = secondaryError.innerError) === null || _secondaryError$inner2 === void 0 ? void 0 : _secondaryError$inner2.message;
  }
  if (secondaryError instanceof Error) {
    return secondaryError.message;
  }
  return error.message;
};
export var getErrorTraceContext = function getErrorTraceContext(error) {
  var secondaryError = error.secondaryError;
  if (isCommonMediaClientError(secondaryError)) {
    var _secondaryError$metad;
    return (_secondaryError$metad = secondaryError.metadata) === null || _secondaryError$metad === void 0 ? void 0 : _secondaryError$metad.traceContext;
  }
};
export var getRenderErrorRequestMetadata = function getRenderErrorRequestMetadata(error) {
  var secondaryError = error.secondaryError;
  if (isCommonMediaClientError(secondaryError)) {
    return secondaryError.metadata;
  }
};
export var extractErrorInfo = function extractErrorInfo(error, metadataTraceContext) {
  return {
    failReason: getRenderErrorFailReason(error),
    error: getRenderErrorErrorReason(error),
    errorDetail: getRenderErrorErrorDetail(error),
    metadataTraceContext: metadataTraceContext !== null && metadataTraceContext !== void 0 ? metadataTraceContext : getErrorTraceContext(error)
  };
};
export var getRenderErrorEventPayload = function getRenderErrorEventPayload(fileAttributes, performanceAttributes, error, ssrReliability, traceContext, metadataTraceContext) {
  var requestMetadata = getRenderErrorRequestMetadata(error);
  return {
    eventType: 'operational',
    action: 'failed',
    actionSubject: 'mediaCardRender',
    attributes: _objectSpread(_objectSpread({
      fileMimetype: fileAttributes.fileMimetype,
      fileAttributes: fileAttributes,
      performanceAttributes: performanceAttributes,
      status: 'fail'
    }, extractErrorInfo(error, metadataTraceContext)), {}, {
      statusCode: requestMetadata === null || requestMetadata === void 0 ? void 0 : requestMetadata.statusCode,
      request: requestMetadata,
      ssrReliability: ssrReliability,
      traceContext: traceContext
    })
  };
};
export var getDownloadFailedEventPayload = function getDownloadFailedEventPayload(fileAttributes, error, traceContext, metadataTraceContext) {
  var requestMetadata = getRenderErrorRequestMetadata(error);
  return {
    eventType: 'operational',
    action: 'failed',
    actionSubject: 'mediaCardDownload',
    attributes: _objectSpread(_objectSpread({
      fileMimetype: fileAttributes.fileMimetype,
      fileAttributes: fileAttributes,
      status: 'fail'
    }, extractErrorInfo(error, metadataTraceContext)), {}, {
      statusCode: requestMetadata === null || requestMetadata === void 0 ? void 0 : requestMetadata.statusCode,
      request: requestMetadata,
      traceContext: traceContext
    })
  };
};
export var getErrorEventPayload = function getErrorEventPayload(cardStatus, fileAttributes, error, ssrReliability, traceContext, metadataTraceContext) {
  var requestMetadata = getRenderErrorRequestMetadata(error);
  return {
    eventType: 'operational',
    action: 'nonCriticalFail',
    actionSubject: 'mediaCardRender',
    attributes: _objectSpread(_objectSpread({
      fileAttributes: fileAttributes,
      status: 'fail'
    }, extractErrorInfo(error, metadataTraceContext)), {}, {
      statusCode: requestMetadata === null || requestMetadata === void 0 ? void 0 : requestMetadata.statusCode,
      request: requestMetadata,
      ssrReliability: ssrReliability,
      traceContext: traceContext,
      cardStatus: cardStatus
    })
  };
};
export var getRenderFailedFileStatusPayload = function getRenderFailedFileStatusPayload(fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext) {
  return {
    eventType: 'operational',
    action: 'failed',
    actionSubject: 'mediaCardRender',
    attributes: {
      fileMimetype: fileAttributes.fileMimetype,
      fileAttributes: fileAttributes,
      performanceAttributes: performanceAttributes,
      status: 'fail',
      failReason: 'failed-processing',
      ssrReliability: ssrReliability,
      traceContext: traceContext,
      metadataTraceContext: metadataTraceContext
    }
  };
};
export function fireMediaCardEvent(payload, createAnalyticsEvent) {
  if (createAnalyticsEvent) {
    var event = createAnalyticsEvent(sanitiseAnalyticsPayload(payload));
    event.fire(ANALYTICS_MEDIA_CHANNEL);
  }
}
export var createAndFireMediaCardEvent = function createAndFireMediaCardEvent(payload) {
  return createAndFireEvent(ANALYTICS_MEDIA_CHANNEL)(sanitiseAnalyticsPayload(payload));
};